<template>
    <!-- 新建生产单-工艺单部分 -->
    <div>
        <br> <!-- 换行 -->

        <el-table :data="craftOrder.craftItems" class="craft-order" :row-style="{height: '0'}"
            :cell-style="{'padding':'0px'}" :header-cell-style="{padding: 0}" border>
            <el-table-column fixed label="梳号" width="50px" prop="combSection" align="center" />

            <el-table-column label="条数" width="50" align="center">
                <template slot-scope="data">
                    <input v-model="data.row.headVeins" class="table-input" />
                </template>
            </el-table-column>
			
			<el-table-column label="盘头数" width="50" align="center">
			    <template slot-scope="data">
			        <input v-model="data.row.panHeadNum" class="table-input" />
			    </template>
			</el-table-column>
			
			<el-table-column label="送经量" width="50" align="center">
			    <template slot-scope="data">
			        <input v-model="data.row.sendYarnFeed" class="table-input" />
			    </template>
			</el-table-column>

			
			<el-table-column label="工艺组织" width="220" align="center">
			    <template slot-scope="data">
			        <input v-model="data.row.organization" class="table-input" />
			    </template>
			</el-table-column>
			
			<el-table-column label="穿纱方式" width="150" align="center">
			    <template slot-scope="data">
			        <input v-model="data.row.crossYarnWay" class="table-input" />
			    </template>
			</el-table-column>
			
			<el-table-column label="备注" width="100" align="center">
			    <template slot-scope="data">
			        <input v-model="data.row.remark" class="table-input" />
			    </template>
			</el-table-column>

            <el-table-column label="批号" width="80" align="center">
                <template slot-scope="data">
                    <input v-model="data.row.materialBatch" class="table-input" />
                </template>
            </el-table-column>

            <el-table-column label="供应商" width="80" align="center">
                <template slot-scope="data">
                    <input v-model="data.row.provider" class="table-input" />
                </template>
            </el-table-column>
			
			<el-table-column label="计划用量" width="80" align="center">
			    <template slot-scope="data">
			        <input v-model="data.row.planLength" class="table-input" />
			    </template>
			</el-table-column>
			
			<el-table-column label="D数" width="80" align="center">
			    <template slot-scope="data">
			        <input v-model="data.row.dcount/100" type="number" class="table-input" disabled="isDisabled"
			            placeholder="请选择胚布" />
			    </template>
			</el-table-column>
			
			<el-table-column label="牵伸系数" width="80" align="center">
			    <template slot-scope="data">
			        <input v-model="data.row.stretchRate/100" type="number" class="table-input" disabled="isDisabled"
			            placeholder="请选择胚布" />
			    </template>
			</el-table-column>
			
			<el-table-column label="占比(%)" width="80" align="center">
			    <template slot-scope="data">
			        <input v-model="data.row.percent" type="number" class="table-input" disabled="isDisabled"
			            placeholder="请选择胚布" />
			    </template>
			</el-table-column>

            <el-table-column label="物料编号" width="80" align="center">
                <template slot-scope="data">
                    <input v-model="data.row.materialNumber" class="table-input" disabled="isDisabled"
                        placeholder="请选择胚布" />
                </template>
            </el-table-column>

            <el-table-column label="物料名称" width="80" align="center">
                <template slot-scope="data">
                    <input v-model="data.row.materialName" class="table-input" disabled="isDisabled"
                        placeholder="请选择胚布" />
                </template>
            </el-table-column>

            <el-table-column label="规格名称" width="80" align="center">
                <template slot-scope="data">
                    <input v-model="data.row.materialStandard" class="table-input" disabled="isDisabled"
                        placeholder="请选择胚布" />
                </template>
            </el-table-column>



            <el-table-column label="单位" width="80" align="center">
                <template slot-scope="data">
                    <input v-model="data.row.unit" class="table-input" disabled="isDisabled" placeholder="请选择胚布" />
                </template>
            </el-table-column>



        </el-table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                craftOrder: {
                    orderName: '',
                    craftRemarks: '',
                    craftItems: [{
                        combSection: 'GB1'
                    }, {
                        combSection: 'GB2'
                    }, {
                        combSection: 'GB3'
                    }, {
                        combSection: 'GB4',
						//目前只需要添加4个即可  liuqy
                    // }, {
                    //     combSection: 'GB5'
                    // }, {
                    //     combSection: 'GB6'
                    // }, {
                    //     combSection: 'GB7'
                    // }, {
                    //     combSection: 'GB8'
                    // }, {
                    //     combSection: 'GB9'
                    // }, {
                    //     combSection: 'GB10'
                    },
					]
                },

                craftItemKeys: {
                    combSection: {
                        value: '梳号',
                        width: 50
                    },

                    headVeins: {
                        value: '条数/粒数',
                        width: 80
                    },
					panHeadNum: {
					    value: '个数/梳节',
					    width: 80
					},
                    materialBatch: {
                        value: '批号',
                        width: 80
                    },
                    provider: {
                        value: '供应商',
                        width: 80
                    },
                    materialNumber: {
                        value: '物料编号',
                        width: 80
                    },
                    materialName: {
                        value: '物料名称',
                        width: 80
                    },
                    materialStandard: {
                        value: '规格名称',
                        width: 80
                    },
                    dcount: {
                        value: 'D数',
                        width: 80
                    },
                    stretchRate: {
                        value: '牵伸系数',
                        width: 80
                    },
                    percent: {
                        value: '占比(%)',
                        width: 80
                    },
                    unit: {
                        value: '单位',
                        width: 80
                    },
                    planLength: {
                        value: '计划用量',
                        width: 80
                    },
                    sendYarnFeed: {
                        value: '送经量',
                        width: 80
                    },
                    organization: {
                        value: '工艺组织',
                        width: 80
                    },
                    remark: {
                        value: '备注',
                        width: 80
                    },
					crossYarnWay: {
					    value: '穿纱方式',
					    width: 80
					},
					
                }
            }
        },
        methods: {
            // 外部调用，获取填写的工艺单数据
            getCraftOrder() {
                const cloneCraftOrder = this._.cloneDeep(this.craftOrder)
                cloneCraftOrder.craftItems = this.clearNullCarftItem(cloneCraftOrder.craftItems)
                return cloneCraftOrder
            },
            // 外部调用，'选择胚布'后 设置 疏节 列表。
            updateCraftOrder(res) {
                console.log('res=', res)

                //先要初始化一次
                let craftItems_initValue = [{
                    combSection: 'GB1'
                }, {
                    combSection: 'GB2'
                }, {
                    combSection: 'GB3'
                }, {
                    combSection: 'GB4',
				//liuqy 保留四个
                // }, {
                //     combSection: 'GB5'
                // }, {
                //     combSection: 'GB6'
                // }, {
                //     combSection: 'GB7'
                // }, {
                //     combSection: 'GB8'
                // }, {
                //     combSection: 'GB9'
                // }, {
                //     combSection: 'GB10'
                },
				]

                this.$set(this.craftOrder, 'craftItems', craftItems_initValue)

                //根据返回值填充
                for (let i = 0; i < res.partItems.length; i++) {
                    // console.log('res.partItems[i].number', res.partItems[i].number)
                    this.$set(this.craftOrder.craftItems[i], 'materialId', res.partItems[i].materialId)
                    this.$set(this.craftOrder.craftItems[i], 'materialNumber', res.partItems[i].number) //物料编号
                    this.$set(this.craftOrder.craftItems[i], 'materialName', res.partItems[i].name) //物料名称

                    this.$set(this.craftOrder.craftItems[i], 'materialStandard', res.partItems[i].specName) //规格名称
                    this.$set(this.craftOrder.craftItems[i], 'percent', res.partItems[i].percent)

                    this.$set(this.craftOrder.craftItems[i], 'dcount', res.partItems[i].dcount)
                    this.$set(this.craftOrder.craftItems[i], 'stretchRate', res.partItems[i].stretchRate)
                    this.$set(this.craftOrder.craftItems[i], 'unit', res.partItems[i].unit)
                    //本行预留
                    // this.$set(this.craftOrder.craftItems[i], 'XXXXXX' , res.partItems[i].XXXXXX)
                }
            },

            // 外部调用，用以判断用户是否填写输入框的内容
            getValid() {
                this.$refs.craftOrderFormRef.validate(valid => {
                    this.valid = valid
                })
                return this.valid
            },
            // 清空为空的工艺对象,只有一个GB的这种
            clearNullCarftItem(craftItems) {
                const formatCraftItems = []
                craftItems.forEach(obj => {
                    if (this._.size(obj) <= 1) {
                        return
                    }
                    for (const key in this.craftItemKeys) {
                        if (this.utils.isEmpty(obj[key])) {
                            obj[key] = ''
                        }
                    }
                    formatCraftItems.push(obj)
                })
                return formatCraftItems
            },

            // 设置工艺单信息
            setCraftOrder(rsponse) {
                // console.log('rsponse.craftItems=', rsponse.craftItems)
                if (0 === rsponse.craftItems.length) {
                    //旧表单中 未填 工艺单信息，不操作，直接 使用 默认结构。
                } else {
                    //复制 旧工艺单信息
                    this.craftOrder = rsponse
                }
            }

        },
        created() {

        }
    }
</script>

<style lang="scss" scoped>
    .table-input {
        width: 100%;
        height: 30px;
        border: 0px;
        outline: none;
        padding: 0;
        margin: 0;
        text-align: center;
    }

    .el-button {
        margin: 6px 10px 0px 0px
    }
</style>
